import React from 'react';

import { RecursiveMenu as RDCRecursiveMenu } from '@uncinc/react-drupal-core';

import withHeading, { type RecursiveMenuWithHeadingProps } from './withHeading';

const RecursiveMenu: React.FC<RecursiveMenuWithHeadingProps> = (props) => (
  <RDCRecursiveMenu {...props} />
);

export default withHeading(RecursiveMenu);
